import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { FieldTypes, userTypes } from '../../utils/constants'
import Form from '../common/Form'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import useUserInvitationsApi from '../../hooks/userInvitations/useUserInvitationsApi'
import ListHeader from '../common/ListHeader'
import useStyles from '../common/FormFields/FormFieldsStyle'
import useUsersApi from '../../hooks/users/useUsersApi'
import { useGetUserInfo } from '../../hooks/useGetUserInfo'
import useApartmentsApi from '../../hooks/apartments/useApartmentsApi'
import useBuildingsApi from '../../hooks/buildings/useBuildingsApi'

export default function ShoppingForm({ onSubmit, handleCancel, shopping }) {
  const classes = useStyles()
  const history = useHistory()
  const userInfo = useGetUserInfo()

  const [values, setValues] = useState({})

  const [{ usersState }, { getUsers }] = useUsersApi()
  const [{ userInvitationState }, { getSettings }] = useUserInvitationsApi()
  const [{ getApartmentsFromBuildingState }, apartmentsMethods] =
    useApartmentsApi()
  const [{ buildingsState }, { getBuildings }] = useBuildingsApi()

  const apartments = getApartmentsFromBuildingState.apartments

  useEffect(() => {
    const fetchData = async () => {
      if (userInfo) {
        getUsers({ type: userTypes.user, buildingId: userInfo?.building?.id })
        getSettings(shopping)
        if (userInfo?.building?.id) {
          apartmentsMethods.getApartmentsFromBuilding(userInfo?.building?.id)
        } else {
          getBuildings()
        }
      }
    }
    fetchData()
  }, [userInfo])

  return (
    <div className={classes.paper}>
      <ListHeader
        bigTitle={shopping ? 'Recepción de cadetería' : 'Arribo de servicios'}
        canCreate={false}
      />
      <Form
        values={values}
        setValues={setValues}
        fields={[
          ...(!userInfo?.building?.id
            ? [
                {
                  type: FieldTypes.Autocomplete,
                  label: 'Cliente',
                  hint: 'Seleccione un cliente',
                  key: 'buildingId',
                  options: buildingsState.buildings,
                  multiple: false,
                  freeSolo: false,
                  withMargin: true,
                  onChange: (value) => {
                    setValues({ ...values, buildingId: value.id })
                    apartmentsMethods.getApartmentsFromBuilding(value.id)
                  },
                  errorMessage: 'El cliente es requerido',
                },
              ]
            : []),
          {
            type: FieldTypes.Autocomplete,
            label: 'Unidad',
            hint: 'Seleccione una unidad',
            key: 'apartmentId',
            options: apartments || [],
            multiple: false,
            freeSolo: false,
            withMargin: true,
            renderTags: () => null,
            disabled: apartments.length === 0,
            onChange: (value) => {
              setValues({ ...values, apartmentId: value.id })
              getUsers({
                type: userTypes.user,
                buildingId: userInfo?.building?.id,
                apartmentId: value.id,
              })
            },
            errorMessage: 'La unidad es requerida',
          },
          {
            type: FieldTypes.Autocomplete,
            label: 'Residente',
            hint: 'Seleccione un residente',
            key: 'userId',
            options: usersState.data.users,
            onChange: (value) => {
              setValues({ ...values, userId: value.id })
            },
            getOptionLabel: (option) => {
              if (option.name && option.surname && option.apartments[0]) {
                return `${option.name} ${option.surname} (${option.apartments[0].name})`
              }
              return ''
            },
            renderOption: (option) => {
              if (option.name && option.surname && option.apartments[0]) {
                return `${option.name} ${option.surname} (${option.apartments[0].name})`
              }
              return ''
            },
            multiple: false,
            freeSolo: false,
            withMargin: true,
          },
          {
            type: FieldTypes.Select,
            id: 'type',
            label: 'Tipo',
            hint: 'Seleccionar tipo',
            key: 'type',
            errorMessage: 'El tipo es requerido',
            withMargin: true,
            renderValue: (selected) => {
              if (!selected) {
                return (
                  <span
                    className={clsx(
                      classes.inputFont,
                      classes.selectPlaceholder
                    )}
                  >
                    Seleccionar tipo
                  </span>
                )
              }
              const selectedOption = userInvitationState?.serviceTypes.find(
                (option) =>
                  option.id === selected ||
                  option.name.replaceAll('_', ' ') === selected ||
                  option.name === selected
              )
              return selectedOption.displayName
            },
            options: userInvitationState?.serviceTypes
              ? userInvitationState?.serviceTypes?.map((type) => ({
                  value: type.id,
                  label: type.displayName,
                }))
              : [],
          },
          {
            type: FieldTypes.TextField,
            label: 'Observaciones',
            hint: 'Ingrese observaciones',
            key: 'observations',
            withMargin: true,
          },
        ]}
        handleSubmit={() => {
          if (values.apartmentId || values.userId) {
            onSubmit({
              ...values,
              type: userInvitationState?.serviceTypes.find(
                (option) => option.id === values.type
              )?.name,
              confirmed: true,
              receivedAt: new Date().toISOString(),
              receivedBy: userInfo?.id,
              opened: true,
              startTime: new Date().toISOString(),
              endTime: new Date().toISOString(),
            })
            history.push(shopping ? '/compras' : '/notificaciones')
          }
        }}
        handleCancel={handleCancel}
      />
    </div>
  )
}
